// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"195":"1ccb2ca5","366":"b6203c35","429":"56fc1f67","587":"482ea9c8","842":"50c80fc3"}[chunkId] + ".chunk.js";
};